module.exports = __webpack_public_path__ + "img/weddings_15_V.9a41a241.webp";